import React from "react"
import styled from '~/ui/styled'
import { formatMessageTime } from "../../utils"

interface Props {
  time: Date
  color?: string
  fontSize?: number | string
}

const Text = styled.Text<{color?: string; fontSize?: number}>`
  width: auto;
  color: ${({ theme, color }) => color || theme.colors.secondaryText};
  font-size: ${({ theme, fontSize }) => (typeof fontSize === "number" ? `${fontSize}px` : fontSize) || theme.fontSizes.xs};
`
// 消息时间组件
const MessageTime: React.FC<Props> = ({ time, color, fontSize }) => {
  return (
    <Text color={color} fontSize={fontSize}>
      {formatMessageTime(time)}
    </Text>
  )
}

export default MessageTime
